import Preact from 'preact'
import { Video } from '../../../center/components/pages/GoalShowPage/Player/Video'
import { Clips, IFirebaseConfig } from '../../../types'
import { initializeFirebaseInstance } from '../../../center/db/firebase'

const { h, Component } = Preact

interface IProps {
  showLikes: boolean
  showViews: boolean
  clips: Clips
  firebaseConfig: IFirebaseConfig
}

class App extends Component<IProps> {
  public componentDidMount() {
    initializeFirebaseInstance(this.props.firebaseConfig)
  }

  public render() {
    const { clips, showLikes, showViews } = this.props

    if (clips && clips.length) {
      return (
        <div>
          <Video
            clipIds={clips.map(({ id }) => id)}
            clips={clips}
            showLikes={showLikes}
            showViews={showViews}
          />
        </div>
      )
    }
    return null
  }
}

export { App }
